import {Component} from 'panel';

import {setOptState} from '../opt.js';

import template from './index.jade';
import './index.styl';

class GdprSettingsPrivacy extends Component {
  get config() {
    return {
      template,
      defaultState: {
        tracking: false,
        storage: false,
      },
      helpers: {
        toggle: async (trackingOrStorage) => {
          const oldOptState = this.state[trackingOrStorage];
          const newOptState = !oldOptState;

          this.updateToggle(trackingOrStorage, newOptState);
          const {success, error} = await setOptState(
            newOptState ? `in` : `out`,
            trackingOrStorage,
          );

          if (!success) {
            this.updateToggle(trackingOrStorage, oldOptState); // change back to original state if request was not successful
            console.error(`Error syncing opt state to server: ${error}`);

          // if we're opting out, reload the page so that vendor snippets can be removed appropriately
          } else if (!newOptState) {
            window.location.reload(true); // true - don't use the cache so the webserver can remove snippets
          }
        },
      },
    };
  }
  updateToggle(trackingOrStorage, on) {
    if (![`tracking`, `storage`].includes(trackingOrStorage)) {
      throw new Error(`invalid input`);
    }
    this.update({...this.state, [trackingOrStorage]: !!on});
  }
}

customElements.define(`mp-gdpr-settings-privacy`, GdprSettingsPrivacy);
